import React, { Component, useRef, useMemo, useState, useEffect } from "react";
import DateRangePicker from "react-daterange-picker";
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

const useStyles = makeStyles((theme) => ({
    container: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: 200,
    },
}));

export default function Filter({
    handleFilterDecks,
    handleFilterRooms,
    handleFilterStatus,
    handleFilterDecksFun,
    handleFilterRoomsFun,
    handleFilterStatusFun,
    catagoriesFilter,
    handleFilterCatogory,
    handleFilterCatogoryFun,
    deckNoData,
    statusData,
    catogorieySelectedData,
    roomNoData
}) {
    const [date, changeDate] = useState(new Date());
    const classes = useStyles();

    console.log(catagoriesFilter)
    
    return(
        <>
            <div className="p-2 grid grid-cols-4 gap-6 ml-2 mr-2">
                <div className="bg-white rounded-lg shadow-xl border">
                    <h1 className="text-sm font-bold p-4">Select Deck</h1>
                        <select
                            name="deck"
                            id="deck"
                            style={{
                                width: "93%",
                                padding: "0.625rem",
                                borderRadius: "0.625rem",
                                marginLeft: "10px",
                                marginBottom: "15px",
                                boxShadow:
                                    "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
                            }}
                            placeholder="Booking Source"
                            onChange={(e)=> handleFilterDecks(e)}
                            value={deckNoData}
                            >
                                <option value={[]} selected disabled>Choose Deck</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                            </select>
                    <button className="bg-opacity-500 py-2 px-4 mb-2 rounded text-sm font-semibold hover:bg-opacity-75 text-gray-600 border ml-3 w-11/12 hover:bg-gray-300" onClick={()=>handleFilterDecksFun()}>Filter By Deck</button>
                </div>
                <div>
                    <div className="bg-white rounded-lg shadow-xl border">
                        <h1 className="text-sm font-bold p-4">Filter By Status</h1>
                            <select
                                name="deck"
                                id="deck"
                                style={{
                                    width: "93%",
                                    padding: "0.625rem",
                                    borderRadius: "0.625rem",
                                    marginLeft: "10px",
                                    marginBottom: "15px",
                                    boxShadow:
                                        "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
                                }}
                                placeholder="Booking Source"
                                onChange={(e)=> handleFilterStatus(e)}
                                value={statusData}
                            >
                                <option value={[]} selected disabled>Choose Status</option>
                                <option value="true">Confirmed</option>
                                <option value="false">Pending</option>
                            </select>
                        <button className="bg-opacity-500 py-2 px-4 mb-2 rounded text-sm font-semibold hover:bg-opacity-75 text-gray-600 border ml-3 w-11/12 hover:bg-gray-300" onClick={()=>handleFilterStatusFun()}>Filter By Status</button>
                    </div>
                </div>
                <div>
                    <div className="bg-white rounded-lg shadow-xl border">
                        <h1 className="text-sm font-bold p-4">Select Catogory</h1>
                            <select
                                name="deck"
                                id="deck"
                                style={{
                                    width: "93%",
                                    padding: "0.625rem",
                                    borderRadius: "0.625rem",
                                    marginLeft: "10px",
                                    marginBottom: "15px",
                                    boxShadow:
                                        "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
                                }}
                                placeholder="Booking Source"
                                onChange={(e)=> handleFilterCatogory(e)}
                                value = {catogorieySelectedData}
                                >
                                    <option value={[]} selected disabled>Choose Catogory</option>
                                    {catagoriesFilter.map((data)=> {
                                        return(
                                            <option value={data[0]}>{data[1]}</option>
                                        )
                                    })}
                            </select>
                        <button className="bg-opacity-500 py-2 px-4 mb-2 rounded text-sm font-semibold hover:bg-opacity-75 text-gray-600 border ml-3 w-11/12 hover:bg-gray-300" onClick={()=>handleFilterCatogoryFun()} >Filter By Catogory</button>
                    </div>
                </div>
                <div>
                    <div className="bg-white rounded-lg shadow-xl border">
                        <h1 className="text-sm font-bold p-4">Search By Room</h1>
                        <input 
                             style={{
                                width: "93%",
                                padding: "0.625rem",
                                borderRadius: "0.625rem",
                                marginLeft: "10px",
                                marginBottom: "15px",
                                boxShadow:
                                    "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
                            }}
                            placeholder="Search room"
                            id="room"
                            onChange={(e)=> handleFilterRooms(e)}
                            value={roomNoData}
                        />
                        <button className="bg-opacity-500 py-2 px-4 mb-2 rounded text-sm font-semibold hover:bg-opacity-75 text-gray-600 border ml-3 w-11/12 hover:bg-gray-300" onClick={()=>handleFilterRoomsFun()} >Search Room</button>
                    </div>
                </div>
            </div>
        </>
    )
}